// src/components/shipment/DocumentIcons.jsx
import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FileText, CheckSquare, Package, FileStack, LucideFileSliders } from 'lucide-react';

const DocumentIcons = ({ click = () => {} }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [tooltipStyle, setTooltipStyle] = useState({});
    const iconRefs = useRef([]);

    useEffect(() => {
        if (hoveredIndex !== null && iconRefs.current[hoveredIndex]) {
            const iconRect = iconRefs.current[hoveredIndex].getBoundingClientRect();
            
            setTooltipStyle({
                position: 'fixed',
                top: `${iconRect.top - 8}px`,
                left: `${iconRect.left + iconRect.width / 2}px`,
                transform: 'translateX(-50%) translateY(-100%)',
                zIndex: 9999,
            });
        }
    }, [hoveredIndex]);

    const docs = [
        { icon: FileText, color: 'bg-slate-100 hover:bg-slate-200 dark:hover:bg-slate-600 dark:bg-slate-800', title: "Dock Receipt" },
        // { icon: Package, color: 'bg-slate-100 hover:bg-slate-200 dark:hover:bg-slate-600 dark:bg-slate-800', title: "Packaging List" },
        // { icon: LucideFileSliders, color: 'bg-slate-100 hover:bg-slate-200 dark:hover:bg-slate-600 dark:bg-slate-800', title: "Commercial Invoice" },
        { icon: FileStack, color: 'bg-slate-100 hover:bg-slate-200 dark:hover:bg-slate-600 dark:bg-slate-800', title: "MBL" },
        { icon: CheckSquare, color: 'bg-slate-100 hover:bg-slate-200 dark:hover:bg-slate-600 dark:bg-slate-800', title: "AR/AP" },
        // { icon: CheckSquare, color: 'bg-slate-100 hover:bg-slate-200 dark:hover:bg-slate-600 dark:bg-slate-800', title: "Certificate of Origin" },
    ];

    return (
        <>
            <div className="flex gap-2">
                {docs.map((doc, i) => (
                    <div
                        key={i}
                        ref={el => iconRefs.current[i] = el}
                        onMouseEnter={() => setHoveredIndex(i)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        {/* Glossy Icon with shine effect */}
                        <div className="relative group">
                            <div
                                onClick={(e) => click(e, doc.title)}
                                className={`
                                    w-9 h-9 rounded-lg flex items-center justify-center 
                                    cursor-pointer transition-all duration-300 
                                     hover:shadow-xl overflow-hidden
                                    ${doc.color}
                                    hover:scale-110
                                `}
                                
                            >
                                {/* Glossy shine overlay */}
                                <div className="absolute inset-0  rounded-full" />
                                <doc.icon className="w-4 h-4 text-gray-700 dark:text-gray-300 " />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Tooltip rendered via Portal */}
            {hoveredIndex !== null && createPortal(
                <div 
                    className="px-2.5 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap"
                    style={tooltipStyle}
                >
                    {docs[hoveredIndex].title}
                    <div 
                        className="absolute w-2 h-2 bg-gray-900 rotate-45"
                        style={{
                            bottom: '-4px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                        }}
                    />
                </div>,
                document.body
            )}
        </>
    );
};

export default DocumentIcons;